var THEME_CUSTOM_PROPERTY_PREFIX = '--lodgify-ui';
export var THEME_CUSTOM_PROPERTY_IDENTIFIERS = {
  ACTION_COLOR: "".concat(THEME_CUSTOM_PROPERTY_PREFIX, "-action-color"),
  ACTION_DARKER_COLOR: "".concat(THEME_CUSTOM_PROPERTY_PREFIX, "-action-darker-color"),
  ACTION_LIGHTER_COLOR: "".concat(THEME_CUSTOM_PROPERTY_PREFIX, "-action-lighter-color"),
  ACTION_CONTRAST_COLOR: "".concat(THEME_CUSTOM_PROPERTY_PREFIX, "-action-contrast-color"),
  LINK_COLOR: "".concat(THEME_CUSTOM_PROPERTY_PREFIX, "-link-color"),
  LINK_DARKER_COLOR: "".concat(THEME_CUSTOM_PROPERTY_PREFIX, "-link-darker-color"),
  BODY_FONT: "".concat(THEME_CUSTOM_PROPERTY_PREFIX, "-body-font"),
  HEADING_FONT: "".concat(THEME_CUSTOM_PROPERTY_PREFIX, "-heading-font"),
  TITLE_FONT: "".concat(THEME_CUSTOM_PROPERTY_PREFIX, "-title-font"),
  SUB_TITLE_FONT: "".concat(THEME_CUSTOM_PROPERTY_PREFIX, "-subtitle-font"),
  LOGO_COLOR: "".concat(THEME_CUSTOM_PROPERTY_PREFIX, "-logo-color"),
  HEADER_COLOR: "".concat(THEME_CUSTOM_PROPERTY_PREFIX, "-header-color"),
  HEADER_LINK_COLOR: "".concat(THEME_CUSTOM_PROPERTY_PREFIX, "-header-link-color")
};